module.exports = __webpack_public_path__ + "static/media/3-birds.d9c4b15d.svg";